import React from 'react' // eslint-disable-line
import { Typography } from '../../../Common'
import styled from 'styled-components'

export type TopStripType = {
  value: string
  link: string
}

type Props = {
  icons: TopStripType[]
}

const renderIconsAndText = (iconsAndValues: TopStripType[]) =>
  iconsAndValues?.map((singleElement) => {
    return loadIconAndText(singleElement)
  })

const loadIconAndText = (singleElement: TopStripType) => (
  <IconValueWrapper key={singleElement.value}>
    {singleElement.link ? (
      <>
        <Link href={singleElement.link}>{singleElement.value}</Link>
        <span className="px-3">|</span>
      </>
    ) : (
      singleElement.value
    )}
  </IconValueWrapper>
)

export const TopNavStrip = ({ icons }: Props) => {
  return (
    <TopNavStripWrapper>
      <Container>
        <TopNavStripParagraph>{renderIconsAndText(icons)}</TopNavStripParagraph>
      </Container>
    </TopNavStripWrapper>
  )
}
const Container = styled.div.attrs({
  className: 'container',
})`
  padding-right: 1.1rem !important;
`

const TopNavStripWrapper = styled.div<{ background?: string }>`
  width: 100%;
  position: relative;
  z-index: 3000;
  background: ${(props) =>
    props.background ? props.background : props.theme.palette.panache};

  @media (max-width: ${({ theme }) => theme.breakpoints.md.max}) {
    display: none;
  }
`

const TopNavStripParagraph = styled.div`
  color: ${(props) =>
    props.color ? props.color : props.theme.palette.silverTree};
  height: 4rem;
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  font-size: 1.2rem;
`

const IconValueWrapper = styled.div.attrs({
  className: 'd-flex align-items-center',
})`
  height: 100%;

  & span {
    font-size: 1.2rem;
  }

  &:last-of-type {
    & span {
      display: none;
    }
  }
`

const Link = styled(Typography).attrs({
  as: 'a',
})<{ href?: string }>`
  font-size: 1.44rem;
  color: ${({ theme }) => theme.palette.silverTree};
`
